import { SaveButton, Toolbar } from 'react-admin'

const MailTextToolBar = () => {

  return (
    <Toolbar>
      <SaveButton />
    </Toolbar>
  )
}

export default MailTextToolBar